import React from 'react';

const TemplateGrHeader = () => {
  return (
    <div className="flex flex-col gap-1 items-center pt-5">
      <div className="absolute top-5 left-5 ...">
        <img src="/pioneer.png" alt="" style={{ maxHeight: 100 }} />
      </div>
      <div className="text-lg font-bold">Warehouse Receipt (GRN)</div>
      <div className="font-bold">PIONEER LOGISTICS CO., LTD.</div>
      <div className="">
        345 Moo. 15 Soi Khlong Bang Ka Si School, Liap Khlong Song Nam,
      </div>
      <div className="">Suvarnabhumi Road, Samuprakarn 10540</div>
    </div>
  );
};

export default TemplateGrHeader;
